import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SitePublicService} from 'src/app/services/site-public.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SiteEventFormDialogComponent} from '../../dialogs/site-event-form-dialog/site-event-form-dialog.component';
//import {SiteEventFormDialogComponent} from '../../dialogs/tavi-doc-dialog/tavi-doc-dialog.component';

@Component({
  selector: 'app-site-events-form',
  templateUrl: './site-events-form.component.html',
  styleUrls: [ './site-events-form.component.scss' ]
})
export class SiteEventsFormComponent implements OnInit, OnDestroy {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'name', 'edit', 'preview', 'delete' ];

  private subscription: Subscription | undefined;


  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor (
    private _sitePublicService: SitePublicService,
    private dialog: MatDialog,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,
    private _dialog: MatDialog,) {

    /*
    if (!this._authService.isAdmin) {
    this.router.navigate([ 'home' ]);
    }
    */

    this.loadData()
  }

  ngOnInit () { }

  ngOnDestroy () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadData() {
    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const statute$ = this._sitePublicService.loadEventSupport();

    // 2. Se inscreve no Observable
    this.subscription = statute$.subscribe({
      next: (array: any[]) => {
        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar o documento:', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }

  openDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'name': ''}
    }

    let dialogRef = this.dialog.open(SiteEventFormDialogComponent, {
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const formData = form.getRawValue();

        if (actionType == 'insert') {
         // console.log("insert: " + JSON.stringify(formData))
          this._sitePublicService.insertEventSupport(formData)
            .then(() => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })
        } else if (actionType == 'update') {
          //console.log("update: " + JSON.stringify(formData))
          this._sitePublicService.updateEventSupport(formData)
            .then(() => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro: " + err.message)
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })
        }

      })

  }

  delete (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.period + "<br><br>Excluir este documento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._sitePublicService.deleteEventSupport(element.id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete document error: " + error.message)}
          )
      }
    })
  }

    previewContent (element) {
    const html = element.html;
    this._sitePublicService.displayHtml(html)
  }
  

}
